import SwiperSmall from './swiper-small';
export default SwiperSmall